export default __webpack_public_path__ + "images/d762d3b612a2ca1dd66f36a7aad3e15b-dance_small.webp";